import React from "react";
import {useState, useEffect} from "react";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from '@mui/icons-material/Cancel';
import Button from "@mui/material/Button";
import WriteComponent from "./WriteComponent";
import PublishIcon from '@mui/icons-material/Publish';
import PreviewIcon from '@mui/icons-material/Preview';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import Blog from "../Blog/Blog";
import {getRequest, postRequest} from "../../Fetch/request";
import PopUp from "../Popup/PopUp";
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';
import {uploadFileToS3} from "../../Utils/UploadToS3";
import generateS3Url from "../../Utils/GenerateS3Url";
import EditIcon from '@mui/icons-material/Edit';
import './WriteStyle.css'
import Loader from "../Loader/Loader";

const Write = ({setTheId,getTheId,id}) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [popUpTitle, setPopUpTitle] = React.useState("");
    const [popUpMsg , setPopUpMsg] = React.useState("");
    const [popUpColor , setPopUpColor] = React.useState("red");

    const setPopProps = (title , msg, color) =>{
        setPopUpMsg(msg);
        setPopUpTitle(title);
        setPopUpColor(color);
    }

    const [x,setX] = React.useState(0);

    const updateParams = () => {
        const newParams = {
            id:uuidv4(),
        };

        // Get the current pathname
        const currentPathname = window.location.pathname;

        // Construct the new URL with updated parameters
        const newURL = `${currentPathname}?preview=false&blogId=${newParams.id}`;

        // Update the URL
        window.history.pushState({}, '', newURL);

        // Force a page reload to reflect the new URL
        window.location.reload();
    };

    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);
    const idValue = urlSearchParams.get('blogId') || urlSearchParams.get('id');
    const previewValue = urlSearchParams.get("preview");
    setTheId(idValue);

    const [articleTitle, setArticleTitle] = useState("");
    const [articleComponent, setArticleComponent] = useState([]);
    const [lengthOfArticle, setLengthOfArticle] = useState(1000);
    const [textOfArticle, setTextOfArticle] = useState(new Array(1001).fill(""));
    const [imageOfArticle, setImageOfArticle] = useState(new Array(1001).fill(""));
    const [fileImageOfArticle, setFileImageOfArticle] = useState(new Array(1001).fill(""));
    const [urlImageOfArticle, setUrlImageOfArticle] = useState(new Array(1001).fill(""));
    const [textAreaActiveOfArticle, setTextAreaActiveOfArticle] = useState(new Array(1001).fill(true));

    const [loader,setLoader] = useState(0);
    const [uploading,setUploading] = useState(0);

    const [preview, setPreview] = useState(previewValue == "false"?false:true);

    // Drag and drop state
    const [draggedIndex, setDraggedIndex] = useState(null);
    const [dragOverIndex, setDragOverIndex] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleTitleChange = (title) => {
        setArticleTitle(title);
    };

    const addComponent = () => {
        textAreaActiveOfArticle[parseInt(lengthOfArticle)] = true;
        setTextAreaActiveOfArticle(textAreaActiveOfArticle);
        setArticleComponent([
            ...articleComponent,
            <WriteComponent
                keyIndex={parseInt(lengthOfArticle)}
                setTextOfArticle={setTextOfArticle}
                textOfArticle={textOfArticle}
                setImageOfArticle={setImageOfArticle}
                imageOfArticle={imageOfArticle}
                textAreaActiveOfArticle={textAreaActiveOfArticle}
                setTextAreaActiveOfArticle={setTextAreaActiveOfArticle}
                addComponent={addComponent}
                urlImageOfArticle={urlImageOfArticle}
                fileImageOfArticle={fileImageOfArticle}
                setFileImageOfArticle={setFileImageOfArticle}
            />,
        ]);
        setLengthOfArticle(lengthOfArticle - 1);
    };

    const removeArticleComponent = (keyIndex) => {
        let newArticleComponent = [];
        newArticleComponent = articleComponent.filter((x) => {
            if (x.props.keyIndex !== keyIndex) {
                return x;
            }
        });
        setArticleComponent(newArticleComponent);
    };

    // Drag and drop functions
    const handleDragStart = (e, index) => {
        setDraggedIndex(index);
        setIsDragging(true);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/html', e.target.outerHTML);
        
        // Prevent text selection during drag
        document.body.style.userSelect = 'none';
        document.body.style.webkitUserSelect = 'none';
        document.body.style.mozUserSelect = 'none';
        document.body.style.msUserSelect = 'none';
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        setDragOverIndex(index);
    };

    const handleDragEnter = (e, index) => {
        e.preventDefault();
        setDragOverIndex(index);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragOverIndex(null);
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        if (draggedIndex === null || draggedIndex === dropIndex) {
            setDragOverIndex(null);
            setIsDragging(false);
            setDraggedIndex(null);
            return;
        }

        // Reorder components
        const newArticleComponent = [...articleComponent];
        const draggedComponent = newArticleComponent[draggedIndex];
        
        // Remove from original position
        newArticleComponent.splice(draggedIndex, 1);
        
        // Insert at new position
        newArticleComponent.splice(dropIndex, 0, draggedComponent);
        
        setArticleComponent(newArticleComponent);
        setDragOverIndex(null);
        setIsDragging(false);
        setDraggedIndex(null);
    };

    const handleDragEnd = () => {
        setDragOverIndex(null);
        setIsDragging(false);
        setDraggedIndex(null);
        
        // Restore text selection
        document.body.style.userSelect = '';
        document.body.style.webkitUserSelect = '';
        document.body.style.mozUserSelect = '';
        document.body.style.msUserSelect = '';
    };

    const publishArticle = async () => {
        // Validate required fields
        if( articleTitle === "" ){
            setPopProps("Alert", "Blog title is required", "red");
            handleOpen();
            return;
        }

        const author = localStorage.getItem('email');
        if( !author || author === "" ){
            setPopProps("Alert", "Author email is required", "red");
            handleOpen();
            return;
        }

        const userId = localStorage.getItem('userId') || (JSON.parse(localStorage.getItem('profileObject') || '{}').id) || 'slazysloth_user';
        if( !userId || userId === "" ){
            setPopProps("Alert", "User ID is required", "red");
            handleOpen();
            return;
        }

        if( !idValue || idValue === "" ){
            setPopProps("Alert", "Blog ID is required", "red");
            handleOpen();
            return;
        }

        setUploading(1);
        let contentArticlePromises = articleComponent.map(async component => {

            if( !component.props.textAreaActiveOfArticle[component.props.keyIndex] )
            {
                component.props.urlImageOfArticle[component.props.keyIndex] = await generateS3Url();
                setUrlImageOfArticle(component.props.urlImageOfArticle);
            }
            return {
                "text": component.props.textOfArticle[component.props.keyIndex],
                "imageUrl":component.props.urlImageOfArticle[component.props.keyIndex],
                "textAreaActive": component.props.textAreaActiveOfArticle[component.props.keyIndex]
            }
        });



        let contentArticle = await Promise.all(contentArticlePromises);
        let articleObject = {
            blogId: idValue,
            title: articleTitle,
            author: author,
            userId: userId,
            createdAt: Date.now(),
            content: contentArticle,
            upVote: 0,
            downVote: 0
        };

        let postResponse = await postRequest(process.env.REACT_APP_URL + "/blog/uploadBlog", articleObject);
        setUploading(0);
        if( postResponse != null && (postResponse.status === "200" || postResponse.status === 200 || postResponse.status === "201" || postResponse.status === 201) && postResponse["response"] != null ){
            const contentUrls = postResponse["response"]["content"];
            for (const component of articleComponent) {
                const index = articleComponent.indexOf(component);
                let image = component.props.fileImageOfArticle[component.props.keyIndex];
                if (image instanceof File && contentUrls[index].text === "" ) {
                    await uploadFileToS3(contentUrls[index].imageUrl, image);
                }
            }

            if( postResponse.hasOwnProperty('response') && postResponse["response"].hasOwnProperty("id") ){
                setTheId(postResponse["response"]["id"]);
                setPopProps("Hurray", postResponse.message, "green");
                handleOpen();
            }
        }else{
            const errorMessage = postResponse?.message || "Upload failed";
            setPopProps("Alert", errorMessage, "red");
            handleOpen();
        }
    }

    return (
        <div
            id="qw"
            style={{
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: "2%",
                textAlign: "center",
                padding: "1%",
                paddingLeft: "5%",
                paddingRight: "5%",
            }}
        >
            <PopUp open={open} handleClose={handleClose} popUpTitle={popUpTitle} popUpMsg={popUpMsg} popUpColor={popUpColor} />

            <div style={{
                position: "fixed",
                right: "0",
                bottom:"0",
                zIndex: 1,
                display:"flex",
            }}>
                {!preview&&<Button
                    component="label"
                    variant="contained"
                    startIcon={<AddIcon/>}
                    onClick={addComponent}
                    style={{
                        backgroundColor:"#008080",
                        color: "white",
                        border: "none",
                        borderRadius:"0px",
                    }}
                >
                    Add
                </Button>}
                <Button
                    component="label"
                    variant="contained"
                    startIcon={ !preview?  <PreviewIcon/>: <EditIcon/>}
                    style={{
                        backgroundColor:"#008080",
                        color: "white",
                        border: "none",
                        borderRadius:"0px"
                    }}
                    onClick={()=>{setPreview(!preview)}}
                >
                    {!preview? "PREVIEW":"EDIT"}
                </Button>

            </div>


            <div style={{
                position: "fixed",
                left: "0",
                bottom:"0",
                zIndex: 1,
                display:"flex",
            }}>
                <Button
                    component="label"
                    variant="contained"
                    startIcon={<CreateNewFolderIcon/>}
                    style={{
                        backgroundColor:"#008080",
                        color: "white",
                        border: "none",
                        borderRadius:"0px"
                    }}
                    onClick={()=>{ updateParams()}}
                >
                    New
                </Button>

                {!preview && <Button
                    component="label"
                    variant="contained"
                    startIcon={<PublishIcon/>}
                    style={{
                        backgroundColor:"#008080",
                        color: "white",
                        border: "none",
                        borderRadius:"0px"
                    }}
                    onClick={publishArticle}
                >
                    Upload
                </Button>}
            </div>

            {uploading === 1 && <PopUp open={true} handleClose={handleClose} popUpTitle={"Uploading"} popUpMsg={"Notes are Uploading"} popUpColor={"pink"} />}
            {loader === 1 && <Loader/>}

            {preview && loader === 0 && (
                    <Blog articleTitle={articleTitle} articleComponent={
                        articleComponent.map(component=>{
                            return {
                                "text" : component.props.textOfArticle[component.props.keyIndex],
                                "image": component.props.imageOfArticle[component.props.keyIndex],
                                "textAreaActive": component.props.textAreaActiveOfArticle[component.props.keyIndex]
                            }
                        })
                    } id={idValue}/>
                )
            }

            {!preview && loader === 0 &&  (
                <>
                    <div>
                        <input
                            type="text"
                            placeholder="Title"
                            style={{
                                width: "80%",
                                fontSize: "2em",
                                textAlign: "center",
                                border: "none",
                                marginBottom: "1%",
                                backgroundColor:"#eee",
                                outline:"none"
                            }}
                            value={articleTitle}
                            onChange={(e) => handleTitleChange(e.target.value)}
                        />
                    </div>


                    {articleComponent.map((component, index) => (
                        <div 
                            key={component.props.keyIndex}
                            className="component"
                            draggable={true}
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => handleDragOver(e, index)}
                            onDragEnter={(e) => handleDragEnter(e, index)}
                            onDragLeave={handleDragLeave}
                            onDrop={(e) => handleDrop(e, index)}
                            onDragEnd={handleDragEnd}
                            style={{
                                cursor: isDragging ? 'grabbing' : 'grab'
                            }}
                        >
                            <div
                                style={{
                                    right:"0%",
                                    center:"0%",
                                    display: "flex",
                                    position:"absolute",
                                    zIndex:"1000",
                                    color:"red"
                                }}
                            >
                                <div style={{borderRadius: "50%"}}>
                                    <CancelIcon
                                        style={{cursor: "pointer"}}
                                        onClick={() => {
                                            removeArticleComponent(parseInt(component.props.keyIndex));
                                        }}
                                    />
                                </div>
                            </div>
                            {component}
                        </div>
                    ))}




                </>
            )}
        </div>
    );
};

export default Write;
